import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "counter", "submitButton", "scheduledFields", "scheduledAt",
                    "publishNowRadio", "scheduleRadio", "saveDraftRadio"]
  static values  = { maxLength: { type: Number, default: 280 } }

  connect() {
    this.updateCounter()
    this.toggleScheduledFields()
  }

  updateCounter() {
    if (!this.hasBodyTarget) return
    const len = this.bodyTarget.value.length
    const remaining = this.maxLengthValue - len

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `残り ${remaining} 文字`
      this.counterTarget.classList.toggle("text-error", remaining < 0)
    }
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = remaining < 0 || len === 0
    }
  }

  toggleScheduledFields() {
    if (!this.hasScheduledFieldsTarget) return
    const checked = this.element.querySelector('input[name="submit_type"]:checked')
    const isScheduled = checked?.value === "schedule"
    this.scheduledFieldsTarget.classList.toggle("hidden", !isScheduled)
  }
}
